// The border only. The old "Scan me" frame is now Rounded with "Scan me" as the
// text below the code (#305), which the Text group sets.
const FRAMES = [
  { value: "none",    label: "No frame", help: "Bare QR code, no border." },
  { value: "rounded", label: "Rounded",  help: "Rounded border around the code and its text." }
]

function Thumb({ frame }) {
  if (frame === "none") {
    return (
      <svg viewBox="0 0 40 40" className="w-10 h-10" aria-hidden="true">
        <rect x="4" y="4" width="32" height="32" fill="#fff" stroke="#E4E4E7" />
        <rect x="10" y="10" width="20" height="20" fill="#111" />
      </svg>
    )
  }
  return (
    <svg viewBox="0 0 40 40" className="w-10 h-10" aria-hidden="true">
      <rect x="2" y="2" width="36" height="36" rx="6" fill="#fff" stroke="#111" strokeWidth="1.5" />
      <rect x="10" y="10" width="20" height="20" fill="#111" />
    </svg>
  )
}

export default function FrameSelect({ value, onChange }) {
  return (
    <fieldset>
      <legend className="sr-only">Frame style</legend>
      <div className="grid grid-cols-2 gap-2">
        {FRAMES.map((f) => {
          const selected = (value || "none") === f.value
          return (
            <label
              key={f.value}
              className={
                "flex flex-col items-center gap-1 p-2 rounded border cursor-pointer transition text-center " +
                (selected
                  ? "border-voltage bg-voltage/5"
                  : "border-[color:var(--color-border)] dark:border-storm hover:border-voltage")
              }
            >
              <input
                type="radio"
                name="frame_style"
                value={f.value}
                checked={selected}
                onChange={() => onChange(f.value)}
                className="sr-only"
              />
              <Thumb frame={f.value} />
              <span className="text-xs font-semibold">{f.label}</span>
            </label>
          )
        })}
      </div>
      <p className="mt-1 text-xs text-[color:var(--color-muted)] dark:text-muted-light">
        {FRAMES.find((f) => (value || "none") === f.value)?.help}
      </p>
    </fieldset>
  )
}
